<template>
    <el-form :model="form" size="mini" :rules="rules" ref="form" label-width="170px">
      <el-form-item label="优惠券名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入优惠券名称"></el-input>
      </el-form-item>
      <el-form-item label="优惠券介绍" prop="introduce">
        <el-input
          v-model="form.introduce"
          placeholder="请输入优惠券介绍"
        ></el-input>
      </el-form-item>
      <el-form-item label="减免金额(元)" prop="reduceCost">
        <el-input
          v-model="form.reduceCost"
          placeholder="请输入减免金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="起用金额(元)" prop="leastCost">
        <el-input
          v-model="form.leastCost"
          placeholder="请输入起用金额"
        ></el-input>
      </el-form-item>
      <el-form-item label="限领数量" prop="limitCount">
        <el-input
          v-model="form.limitCount"
          placeholder="请输入限领数量"
        ></el-input>
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime">
        <el-date-picker
          v-model="form.startTime"
          type="datetime"
          placeholder="选择开始时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime">
        <el-date-picker
          v-model="form.endTime"
          type="datetime"
          placeholder="选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="优惠券类型">
        <el-select
          class="filter-item"
          v-model="form.type"
          placeholder="请选择"
        >
          <el-option
            v-for="item in customized"
            :key="item.index"
            :label="item.name"
            :value="item.index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="使用类型" prop="name">
        <el-radio-group :disabled="disabled"  v-model="form.useScope">
          <el-radio :label="1" >全场通用</el-radio>
          <el-radio :label="2">指定分类</el-radio>
          <el-radio :label="3" >指定商品</el-radio>
          <el-radio :label="4">线下使用</el-radio>
          <el-radio :label="5" :disabled="disabledId&&!perMission">商家服务</el-radio>
          <el-radio :label="6" :disabled="disabledId&&!perMission">智能推介</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="核销商家" v-if="form.useScope === 4">
         <select-user :value="form.merchantIdList" @update:value="form.merchantIdList = $event">
         </select-user>
      </el-form-item>
      <el-form-item label="指定分类" v-if="form.useScope === 2">
        <el-select class="filter-item" multiple v-model="form.categoryIds" placeholder="请选择">
          <el-option
            v-for="item in productClassification"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.useScope === 3" label="指定商品">
          <select-goods :value="form.goodsIds" @update:value="form.goodsIds = $event">
          </select-goods>
      </el-form-item>
      <el-form-item v-if="form.useScope === 5" label="指定产品">
        <select-product :value="form.productIds" @update:value="form.productIds = $event">

        </select-product>
      </el-form-item>
    </el-form>
</template>

<script>
import { mapGetters } from 'vuex'
import { getClassificationd } from '@/api/demo/classification/index'
import commodity from '@/components/commodity/shop.vue'
import {
  getInfoD
} from '@/api/demo/discount/index'
import SelectUser from '@/components/users/selectUser.vue'
import SelectGoods from '@/components/commodity/selectGoods.vue'
import SelectProduct from '@/components/product/selectProduct.vue'
import { getCipherUpdate } from '@/api/demo/command'
import data from '@/components/d2-icon-select/data'
export default {
  components: {
    SelectGoods,
    SelectUser,
    SelectProduct,
    commodity // 商品选择组件
  },
  name: 'addCoupon',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      tableKey: 0,
      form: {
        name: undefined, // 名称
        introduce: null, // 介绍
        reduceCost: null, // 减免金额
        leastCost: null, // 起用金额
        limitCount: null, // 限领数量
        startTime: null, // 开始时间
        endTime: null, // 结束时间
        stat: 1, // 状态
        type: 1, // 类型
        useScope: 1, // 使用范围
        categoryIds: [], // 产品分类
        goodsIds: [], // 商品分类
        merchantIds: [] // 核销商家
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入优惠券名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        introduce: [
          {
            required: true,
            message: '请输入优惠券介绍',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        reduceCost: [
          {
            required: true,
            message: '请输入减免金额',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        leastCost: [
          {
            required: true,
            message: '请输入起用金额',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        limitCount: [
          {
            required: true,
            message: '请输入限领数量',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ]
      },
      productClassification: [], // 产品分类
      customized: [
        { index: 1, name: '全场赠券' },
        { index: 2, name: '会员赠券' },
        { index: 3, name: '购物赠券' },
        { index: 4, name: '注册赠券' },
        { index: 5, name: '后台发放' }
      ]
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  watch: {
    value: {
      handler (val) {
        console.log('handler', val)
        this.form = val
      },
      deep: true
    }
  },
  mounted () {
    this.getCateList()
    if (this.id != null) {
      this.getInfo(this.id)
    }
  },
  methods: {
    getInfo (id) {
      let that = this
      getInfoD(id).then(res => {
        that.form = res
      })
    },
    getCateList () {
      let that = this
      getClassificationd().then(res => {
        that.productClassification = res
      })
    },
    // 验证表单
    verifyForm (callback) {
      this.$emit('update:value', this.form)
      this.$refs['form'].validate(valid => {
        callback(valid)
      })
    }
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
  margin-top: 30px;
}
.el-dialog__footer {
  display: flex;
}
</style>
